<ng-container *transloco="let t; read: 'inbox-voicemail-play'">
  <p-toast position="bottom-center"></p-toast>
  <app-audio-player
    *ngIf="!errorGettingPlayURL && !loading"
    class="full-width"
    [autoplay]="true"
    [playURL]="playURL"
  ></app-audio-player>
  <app-progress-spinner *ngIf="loading"></app-progress-spinner>
</ng-container>
